// extracted by mini-css-extract-plugin
export default {"text":"_1SHseHWW","toggle":"_2uwJ3VVA"};